import PropTypes from 'prop-types';

import GeneralControllers from './GeneralControllers';
import StyleControllers from './StyleControllers';
import LabelControllers from './LabelControllers';
import AxisControllers from './AxisControllers';
import LegendControllers from './LegendControllers';
import InteractivityController from './InteractivityController';
import MarkerControllers from './MarkerControllers';

const Controllers = ({
  config = undefined,
  data = undefined,
  handle = () => {},
  extend = '',
  setExtend = () => {},
  selectedLine = undefined,
  selectedColumn = undefined,
  selectedLineMap = undefined,
  selectedColumnMap = undefined,
  selectedDrilldown = undefined,
  isGlobalThemeActive = false,
  isGlobalFontActive = false,
  forDrilldown = false,
}) => (
  <>
    {[
      GeneralControllers,
      StyleControllers,
      LabelControllers,
      AxisControllers,
      LegendControllers,
      InteractivityController,
      MarkerControllers,
    ].map((Group) => (
      <Group
        key={Group.name}
        handle={handle}
        config={config}
        data={data}
        extend={extend}
        setExtend={setExtend}
        selectedLine={selectedLine}
        selectedLineMap={selectedLineMap}
        selectedColumn={selectedColumn}
        selectedColumnMap={selectedColumnMap}
        selectedDrilldown={selectedDrilldown}
        isGlobalThemeActive={isGlobalThemeActive}
        isGlobalFontActive={isGlobalFontActive}
        forDrilldown={forDrilldown}
      />
    ))}
  </>
);

Controllers.propTypes = {
  config: PropTypes.shape({}),
  data: PropTypes.shape({}),
  handle: PropTypes.func,
  extend: PropTypes.string,
  setExtend: PropTypes.func,
  selectedLine: PropTypes.shape({}),
  selectedLineMap: PropTypes.shape({}),
  selectedColumn: PropTypes.shape({}),
  selectedColumnMap: PropTypes.shape({}),
  selectedDrilldown: PropTypes.shape({}),
  isGlobalThemeActive: PropTypes.bool,
  isGlobalFontActive: PropTypes.bool,
  forDrilldown: PropTypes.bool,
};

export default Controllers;
